/**
 * Emscripten (Pyodide) filesystem helpers shared by the services that mirror
 * files into Pyodide's in-memory FS.
 */

/**
 * Create the parent folders of `fullPath` (e.g. files/sub for files/sub/y.txt).
 * Emscripten's writeFile does not create them, so a write under a new folder
 * would fail. Existing folders are fine.
 */
export function ensureParentDirs(fs: { mkdirTree: (path: string) => void }, fullPath: string): void {
  const lastSlash = fullPath.lastIndexOf('/');
  if (lastSlash <= 0) {
    return;
  }
  try {
    fs.mkdirTree(fullPath.substring(0, lastSlash));
  } catch {
    // Parent directory may already exist
  }
}
